var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-200"},[_c('div',{staticClass:"mb-75"},[_c('h3',{staticClass:"list_heading"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"list_description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }